{
  "version": 1,
  "asset_id": "721d8c7d-b689-40d5-a0d0-33dc9249169c",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/721d8c7d-b689-40d5-a0d0-33dc9249169c/mrdrive-marketplace.png",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/721d8c7d-b689-40d5-a0d0-33dc9249169c/mrdrive-marketplace.png",
  "original_filename": "mrdrive-marketplace.png",
  "size": 2130223,
  "content_type": "image/png",
  "created_at": "2026-07-28T04:39:02Z"
}
